import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../../../../../app/modules/auth'
import { getProfileCompletionAPI } from '../../../../../app/modules/profile/core/_requests'
import { toAbsoluteUrl } from '../../../../helpers'
import { CreateInvestorModal } from '../../../../../app/modules/investor-database/components/CreateInvestorModal'
import { useInvestorDatabase } from '../../../../../app/modules/investor-database/core/InvestorContext'
import { BasicButton } from '../../../../../app/modules/widgets/components/UI/BasicButton'
import { toast } from 'react-toastify'
import { createInvestorCSV } from '../../../../../app/modules/investor-crm/core/_requests'
import { CSVBoxButton } from '@csvbox/react'
import { useThemeMode } from '../../../../partials'
// import { roleValues } from '../../../../../app/core/_constants'

const ToolbarClassic = () => {
  const { companyId, currentUser} = useAuth()
  const location = useLocation()
  const { formatMessage } = useIntl()
  const navigate = useNavigate()
  const [status, setStatus] = useState(0)
  const [showModal, setShowModal] = useState(false)
  const { setPitchDeckModalShow } = useInvestorDatabase()
  const { billingData, setShowBillingModal } = useAuth()

  const { mode } = useThemeMode()
  const {
    setWillRun,
    setWillEditRun,
    investorUpdateLoading,
    investorUpdate,
    setWillDeleteRun,
    setWillCopyRun,
    isEditing,
    investorUpdatePLoading,
  } = useInvestorDatabase()
  const [showKebabMenu, setShowKebabMenu] = useState(false)

  useEffect(() => {
    const getProfileCompletionData = async () => {
      try {
        if (companyId) {
          const {
            data: { data: values, success },
          } = await getProfileCompletionAPI(companyId)
          if (success) {
            setStatus(values)
          }
        }
      } catch (err) {
        console.log(err)
      }
    }
    getProfileCompletionData()
  }, [companyId])

  const importedFileUpload = async (data: any) => {
    if (companyId) {
      data.investors.forEach((investor: any) => {
        if (investor.fund_type) {
          investor.fund_type = JSON.stringify(investor.fund_type.split(','))
        }
        const contacts = []
        for (let i = 1; i <= 3; i++) {
          const designation = investor[`contact${i}_designation`]
          const email = investor[`contact${i}_email`]
          const name = investor[`contact${i}_name`]
          const phone = investor[`contact${i}_phone`]
          const linkedin_url = investor[`contact${i}_linkedin_url`]

          if (designation || email || name || phone || linkedin_url) {
            contacts.push({ designation, email, name, phone, linkedin_url })
          }
          delete investor[`contact${i}_designation`]
          delete investor[`contact${i}_email`]
          delete investor[`contact${i}_name`]
          delete investor[`contact${i}_phone`]
          delete investor[`contact${i}_linkedin_url`]
        }

        investor.investorUser = contacts
      })
      const {
        data: { success, errors },
      } = await createInvestorCSV(data, +companyId)
      if (success) {
        toast.success(formatMessage({ id: 'Successfully uploaded investors from the file.' }))
      } else if (errors) {
        errors?.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
      }
    }
  }
  return (
    <>
      {location.pathname.includes('/settings') && (
        <div className='d-flex align-items-center gap-2 gap-lg-3'>
          <div className='d-flex align-items-center w-200px w-sm-300px flex-column mt-3'>
            <div className='d-flex justify-content-between w-100 mt-auto mb-2'>
              <span className='font-size-13 text-gray-600'>
                {formatMessage({ id: 'Profile Completion' })}
              </span>
              <span className='font-size-13 text-gray-600'>{status}%</span>
            </div>
            <div className='h-8px mx-3 w-100 mb-3 rounded' style={{ backgroundColor: '#a1a5b7' }}>
              <div
                className='rounded h-8px'
                role='progressbar'
                style={{ width: `${status}%`, backgroundColor: '#4776E6' }}
              ></div>
            </div>
          </div>
        </div>
      )}
      {(location.pathname.includes('/prospective-investor') ||
        location.pathname.includes('/existing-investor') ||
        location.pathname.includes('/all-investor')) && (
          <div className='d-flex align-items-center gap-2 gap-lg-3 '>
            <div className='d-flex ms-7  w-md-300px flex-column mt-3 top-btn-main w-100'>
              <div className='d-flex gap-md-2 gap-2 ms-n6 justify-content-end me-4 flex-md-row flex-column'>
                {/* {role && role !== roleValues.BILLING && role !== roleValues.FRM && ( */}
                {(
                  <CSVBoxButton
                    licenseKey={process.env.REACT_APP_CSVBOX_LICENSE_KEY}
                    user={{
                      user_id: `${currentUser?.userId}`,
                    }}
                    onImport={(result: any, data: any) => {
                      if (result) {
                        const sendData = {
                          investors: data.rows,
                        }
                        importedFileUpload(sendData)
                      } else {
                        toast.error(formatMessage({ id: 'File import failed, Please try later' }))
                      }
                    }}
                    render={(launch: any) => {
                      return (
                        <>
                          {billingData?.subscription_items[0].item_price_id.split('-')[0] ===
                            'Basic' ? (
                            <button
                              // className={`border border-primary btn text-primary font-size-13 font-weight-400 height-36 py-md-0 py-8 d-flex align-items-center px-3 ${(role === roleValues.CURATOR || role === roleValues.IRM) &&
                              className={`border border-primary btn text-primary font-size-13 font-weight-400 height-36 py-md-0 py-8 d-flex align-items-center px-3 
                                `}
                              onClick={() => setShowBillingModal(true)}
                            >
                              {mode === 'dark' ? (
                                <img
                                  src={toAbsoluteUrl('/media/icons/investor/lock.svg')}
                                  alt='lock icon'
                                  width={15}
                                  className={`me-2 `}
                                  height={15}
                                />
                              ) : (
                                <img
                                  src={toAbsoluteUrl('/media/icons/investor/darkLock.svg')}
                                  alt='lock icon'
                                  width={15}
                                  className={`me-2 `}
                                  height={15}
                                />
                              )}

                              {formatMessage({ id: 'Import Investor' })}
                            </button>
                          ) : (
                            <button
                              className='border border-primary btn text-primary font-size-13 font-weight-400 height-36 py-md-0 py-8 d-flex w-100 justify-content-center align-items-center px-3'
                              onClick={launch}
                            >
                              {formatMessage({ id: 'Import Investor' })}
                            </button>
                          )}
                        </>
                      )
                    }}
                  ></CSVBoxButton>
                )}

                <button
                  className='btn btn-bg-primary font-size-13 text-white font-weight-400 height-36 py-md-0 py-8 d-flex align-items-center justify-content-center'
                  onClick={() => setShowModal(true)}
                >
                  {formatMessage({ id: 'Create Investor' })}
                </button>
              </div>
            </div>
          </div>
        )}

      {location.pathname.includes('create-investor') && (
        <div className='d-flex align-items-center gap-2 gap-lg-3'>
          <div className='d-flex align-items-center w-200px w-sm-300px flex-column mt-3 top-btn-main'>
            <div className='d-flex gap-6 col-11'></div>
          </div>
        </div>
      )}

      {location.pathname.includes('/updates/update') && (
        <div className='d-flex align-items-center gap-2 gap-lg-3'>
          <div className='d-flex flex-column mt-3 top-btn-main w-100'>
            <div className='d-flex justify-content-end'>
              <button
                className='btn btn-bg-primary font-size-13 text-white font-weight-400 w-100'
                onClick={() => navigate('/updates/create-update')}
              >
                {formatMessage({ id: 'Create Update' })}
              </button>
            </div>
          </div>
        </div>
      )}
      {location.pathname.includes('pitch-deck') && (
        <div className='d-flex align-items-center gap-2 gap-lg-3'>
          <div className='d-flex flex-column mt-3 top-btn-main w-100'>
            <div className='d-flex justify-content-end'>
              <button
                className='btn btn-bg-primary font-size-13 text-white font-weight-400 w-100'
                onClick={() => setPitchDeckModalShow(true)}
              >
                {formatMessage({ id: 'Upload Pitch Deck' })}
              </button>
            </div>
          </div>
        </div>
      )}

      {location.pathname.includes('send-emails') && (
        <div className='d-flex align-items-center gap-2 gap-lg-3'>
          <div className='d-flex flex-column mt-3 top-btn-main w-100'>
            <div className='d-flex justify-content-end'>
              <button
                className='btn btn-bg-primary font-size-13 text-white font-weight-400 w-100'
                onClick={() => navigate('/updates/compose')}
              >
                {formatMessage({ id: 'Send new email' })}
              </button>
            </div>
          </div>
        </div>
      )}

      {location.pathname.includes('templates') && (
        <div className='d-flex align-items-center gap-2 gap-lg-3'>
          <div className='d-flex flex-column mt-3 top-btn-main w-100'>
            <div className='d-flex justify-content-end'>
              <button
                className='btn btn-bg-primary font-size-13 text-white font-weight-400 w-100'
                onClick={() => navigate('/updates/create-template')}
              >
                {formatMessage({ id: 'Create New Template' })}
              </button>
            </div>
          </div>
        </div>
      )}

      {location.pathname.includes('/create-update') && (
        <div className='mt-4 d-flex ms-6'>
          <div className='d-flex gap-4 gap-md-4 ms-n6 flex-wrap'>
            <div>
              <button
                className='btn text-primary font-size-13 text-white font-weight-400'
                style={{ backgroundColor: 'rgba(71, 118, 230, 0.1)' }}
                disabled={investorUpdate?.uuid ? false : true}
              >
                <Link to={`updates/preview/${investorUpdate?.updateId}`} target='_blank'>
                  {formatMessage({ id: 'Preview' })}
                </Link>
              </button>
            </div>
            <div>
              {isEditing ? (
                <>
                  <BasicButton
                    buttonText={formatMessage({ id: 'Save updates' })}
                    disabled={investorUpdateLoading}
                    loading={investorUpdateLoading}
                    height='44px'
                    width='130px'
                    border='1px solid #4776E6'
                    color='#FFFFFF'
                    textColor='#4776E6'
                    padding='12px 20px'
                    darkTheme={true}
                    onClick={() => {
                      setWillEditRun(true)
                    }}
                  />
                </>
              ) : (
                <>
                  <BasicButton
                    buttonText={formatMessage({ id: 'Save updates' })}
                    disabled={investorUpdateLoading || (investorUpdate?.uuid ? true : false)}
                    loading={investorUpdateLoading}
                    height='40px'
                    width='130px'
                    border='1px solid #4776E6'
                    color='#FFFFFF'
                    textColor='#4776E6'
                    // padding='12px 20px'
                    darkTheme={true}
                    onClick={() => {
                      setWillRun(true)
                    }}
                  />
                </>
              )}
            </div>
            <div>
              <button
                className='btn bg-white p-md-2'
                onClick={() => navigate('/updates/send-emails')}
              >
                <img
                  src={toAbsoluteUrl('/media/icons/investor-updates/share_arrow.svg')}
                  alt=''
                  width={25}
                  height={25}
                />
              </button>
            </div>
            <div>
              <BasicButton
                buttonText={
                  investorUpdate?.status === 'PUBLISHED'
                    ? formatMessage({ id: 'Unpublish' })
                    : formatMessage({ id: 'Publish' })
                }
                disabled={investorUpdate ? false : true}
                loading={investorUpdatePLoading}
                minWidth={120}
                height='44px'
                width='120px'
                border='1px solid #4776E6'
                color='#4776E6'
                textColor='#FFFFFF'
                padding='8px 24px'
                onClick={() => {
                  setWillRun(true)
                }}
              />
            </div>
            <div className='investor_update_kebab'>
              <div
                className={`bi bi-three-dots-vertical p-4 cursor-pointer border bg-white rounded h-45px `}
                onClick={() => setShowKebabMenu(!showKebabMenu)}
              ></div>
              {showKebabMenu && (
                <div
                  className='card shadow rounded kebab-menu-dropdown-container cursor-pointer z-index-1'
                  onMouseLeave={() => setShowKebabMenu(false)}
                >
                  {investorUpdate?.status === 'PUBLISHED' && (
                    <div className='border-bottom border-gray-300 border-bottom-2 px-4 py-3 dropdown-items'>
                      <button
                        type='button'
                        className='m-0 border-0 bg-transparent dropdown_dark_text font-size-12'
                        onClick={() => {
                          navigator.clipboard.writeText(
                            `${window.location.origin}/updates/view/${investorUpdate?.uuid}`
                          )
                          toast.success(formatMessage({ id: 'URL Copied Successfully' }))
                        }}
                      >
                        {formatMessage({ id: 'Copy share URL' })}
                      </button>
                    </div>
                  )}
                  <div className='border-bottom border-gray-300 border-bottom-2 px-4 py-3 dropdown-items'>
                    <button
                      type='button'
                      className='m-0 border-0 bg-transparent dropdown_dark_text font-size-12'
                      onClick={() => navigate('/updates/send-emails')}
                    >
                      {formatMessage({ id: 'Send Updates' })}
                    </button>
                  </div>
                  <div className='border-bottom border-gray-300 border-bottom-2 px-4 py-3 dropdown-items '>
                    <button
                      className='m-0 border-0 bg-transparent dropdown_dark_text font-size-12'
                      onClick={() => {
                        setWillCopyRun(true)
                      }}
                      disabled={investorUpdate ? false : true}
                    >
                      {formatMessage({ id: 'Create a Copy' })}
                    </button>
                  </div>
                  <div className='px-4 py-3 dropdown-items'>
                    <button
                      className='m-0 border-0 bg-transparent dropdown_dark_text font-size-12'
                      onClick={() => {
                        setWillDeleteRun(true)
                      }}
                      disabled={investorUpdate ? false : true}
                    >
                      {formatMessage({ id: 'Delete' })}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      <CreateInvestorModal showModal={showModal} setShowModal={setShowModal} />
    </>
  )
}

export { ToolbarClassic }
